import { Navigate, createBrowserRouter } from 'react-router'
import { LoginView } from './features/auth/LoginView.tsx'
import { AppShell } from './features/shell/AppShell.tsx'
import { LoginGate } from './features/auth/LoginGate.tsx'
import { BoardView } from './features/tasks/BoardView.tsx'
import { TableView } from './features/tasks/TableView.tsx'
import { NotesView } from './features/notes/NotesView.tsx'
import { HelpView } from './features/help/HelpView.tsx'
import { HomeView } from './features/home/HomeView.tsx'
import { SettingsView } from './features/settings/SettingsView.tsx'
import { RouteError } from './features/shell/RouteError.tsx'

/**
 * errorElement on every route, not just the root: attached to the children, a throw inside one
 * view is caught while AppShell stays mounted, so the navigation and presence keep working and
 * the person can click their way out. On the root it would replace the entire application with
 * an error page.
 */
export const router = createBrowserRouter([
  {
    path: '/login',
    element: (
      <LoginGate>
        <LoginView />
      </LoginGate>
    ),
    errorElement: <RouteError />,
  },
  {
    path: '/',
    element: <AppShell />,
    errorElement: <RouteError />,
    children: [
      { index: true, element: <HomeView />, errorElement: <RouteError /> },
      { path: 'board', element: <BoardView />, errorElement: <RouteError /> },
      { path: 'table', element: <TableView scope="open" />, errorElement: <RouteError /> },
      { path: 'closed', element: <TableView scope="closed" />, errorElement: <RouteError /> },
      { path: 'notes', element: <NotesView />, errorElement: <RouteError /> },
      { path: 'help', element: <HelpView />, errorElement: <RouteError /> },
      { path: 'settings', element: <SettingsView />, errorElement: <RouteError /> },
    ],
  },
  { path: '*', element: <Navigate to="/" replace /> },
])
